import type { AgentChatResponse } from "@/api/types";
import { AgentProgressStep } from "@/components/agent/AgentProgressStep";
import { Badge } from "@/components/ui/badge";

interface AgentPlanViewProps {
  response: AgentChatResponse;
}

export function AgentPlanView({ response }: AgentPlanViewProps) {
  const hasPlan = Boolean(response.plan?.length);
  const hasExecutionLog = Boolean(response.execution_log?.length);

  if (!hasPlan && !hasExecutionLog) {
    return null;
  }

  return (
    <div className="space-y-4 rounded-[28px] border border-border/70 bg-background-elevated/90 p-4 shadow-sm">
      <div className="flex flex-wrap items-center gap-2">
        <h3 className="text-sm font-semibold text-text-primary">Current AI plan</h3>
        <Badge variant={response.status === "completed" ? "success" : response.status === "failed" ? "danger" : "warning"}>
          {response.status}
        </Badge>
        <span className="text-xs text-text-tertiary">{response.tool_call_count} tool calls in this session</span>
      </div>

      {hasPlan ? (
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-text-tertiary">Planned steps</p>
          {response.plan?.map((step) => (
            <AgentProgressStep key={`${step.tool_call_id ?? step.tool_name}-${step.description}`} mode="plan" step={step} />
          ))}
        </div>
      ) : null}

      {hasExecutionLog ? (
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-text-tertiary">Execution log</p>
          {response.execution_log?.map((step) => (
            <AgentProgressStep key={`${step.tool_call_id ?? step.tool_name}-${step.started_at}`} mode="execution" step={step} />
          ))}
        </div>
      ) : null}
    </div>
  );
}
